import {Popup} from "../../components/popup/popup";
import {useEffect, useState} from "react";
import {ProjectPopup} from "./project-popup";

export const MorphographPopup = ({show, onClose}) => {
  const [maxImageWidth, setMaxImageWidth] = useState("50%");

  const onResize = () => {
    setMaxImageWidth(window.innerWidth < 900 ? "100%" : "50%")
  }

  useEffect(() => {
    window.addEventListener("resize", onResize)
    return () => {
      window.removeEventListener("resize", onResize)
    }
  }, [])

  return (
    <Popup show={show} onClose={onClose} style={{width: "70%", minWidth: 400, position: "relative"}} >
      <div className={"close-btn"} onClick={onClose}>
        <img src={require("../../images/icons/close.png")} style={{width: 20, height: 20, objectFit: "contain"}}/>
      </div>
      <ProjectPopup>
        <div style={{flex: 1, display: "flex", flexDirection: "column"}}>
          <div className={"popup-header"}>
            <span className={"subtitle"}
                  style={{fontSize: 25}}>MorphoGraph</span>
          </div>
          <div style={{overflow: "hidden", padding: 10, display:"flex", flexDirection: "column", flex: 1, alignItems: "flex-start"}}>
            <div className={"scrollbox"}>
              <span style={{fontFamily: "Roboto"}}>
                MorphoGraph is a developmental encoding for modular, evolvable animal body plans, written up as a
                research paper for the Artificial Life conference. Developmental encodings usually trade away
                expressivity to stay evolvable and cheap to simulate; MorphoGraph challenges that tradeoff with a
                graph-based genotype–phenotype representation built for massively parallel evolution.
                <br/><br/>
                The genome is an acyclic graph of developmental subprograms joined by directed edges that act as
                conditional creation rules. Each subprogram holds a weight matrix over a 20-dimensional context: an
                eight-channel local developmental state, a four-channel organism-global state, an anterior–posterior
                axis, a within-chain position with four Fourier channels encoding it, a developmental age, and a bias.
                Eight outputs feed the local state back through a recurrent tanh nonlinearity so it drifts from segment
                to segment, while nonlinear readout heads map the same context to segment count, geometry, curvature,
                pigmentation, tissue composition (bone, muscle, nerve, fat), and cross-sectional profile. Edges decide
                if and where a child segment appears, its attachment angle, and how the parent context blends with the
                child's evolved seed state. Subprograms also carry NEAT innovation numbers so compatible genomes can be
                aligned for sexual recombination.
                <br/><br/>
                Traits decode into bodies made of connected 2D capsule segments with functional interior tissues and
                exterior structures such as mouths, sensors, spikes, and reproductive organs. Together this gives the
                encoding a set of properties that existing approaches only satisfy in part: complexity is earned
                gradually, since structural mutations are born silent and express only as selection grows their weight;
                the cheap route to novelty is duplicating and diverging an existing subprogram (serial homology) or
                re-expressing a structure at a new site (co-option); a single position-dependent rule can express the
                same subprogram at many sites that then specialise by axial position, much like arthropod appendages;
                and per-subprogram growth schedules separate when a structure appears from its adult geometry, which
                makes metamorphosis and juvenile-to-adult change possible.
                <br/><br/>
                Bodies are solved as 2D rigid capsule assemblies by an XPBD solver, with joints edge-coloured for
                parallel Gauss–Seidel and small organisms bin-packed into fixed-width GPU workgroups. An anisotropic
                water-drag model, where lateral resistance exceeds axial resistance, rectifies muscle oscillation into
                net thrust following resistive-force theory, and a motion-sleep test skips resting organisms so cost
                tracks only the mobile population.
                <br/><br/>
                On a single Apple M1 Pro the physics solver averages 164 steps per second across 25,000 concurrent
                organisms totalling 117,000 body segments. A continuous evolutionary run produced diverse,
                multi-segmented species diverging from a shared ancestor, and 1000 generations of directed selection
                against a metamorphic "butterfly" fitness function — scored on a streamlined juvenile and a broad adult —
                demonstrated smooth mutation, metamorphic development, serial homology, and graded complexity.
             </span>
            </div>
            <div className={"link-row"}
                 style={{marginTop: 10}}>
              <div className={"link"}
                   onClick={() => window.open(process.env.PUBLIC_URL + '/MorphoGraph.pdf', 'mywindow')}>
                <span>Paper</span>
              </div>
              <div className={"link"}
                   onClick={() => window.open('https://github.com/seanjhardy/MorphoGraph', 'mywindow')}>
                <span>Github</span>
              </div>
            </div>
          </div>
        </div>
        <img src={require("../../images/background/morphograph.png")}
             className={"popup-video-card"}
             style={{aspectRatio: 1.92, maxWidth: maxImageWidth, objectFit: "contain", backgroundColor: "#000000"}}/>
      </ProjectPopup>
    </Popup>
  )
}
